import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Link } from '@heroui/react';
import { EmptyState } from '@heroui-pro/react';
import { PATH } from '@/router/PATH';
import { getNodeTestIdProp } from '@/utils';

/**
 * What the details and edit pages show for a product that no longer exists
 * (bos-app#136): reached from a bookmark, a shared link or history after a
 * delete. It says so and leads back to the Products list. It offers no Try
 * again, which could never succeed.
 */
export const ProductNotFound: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <EmptyState {...getNodeTestIdProp('product-not-found')}>
            <EmptyState.Header>
                <EmptyState.Media variant="icon">
                    <Icon aria-hidden icon="gravity-ui:box" />
                </EmptyState.Media>
                <EmptyState.Title>
                    {t('products.notFound.title')}
                </EmptyState.Title>
                <EmptyState.Description>
                    {t('products.notFound.description')}
                </EmptyState.Description>
            </EmptyState.Header>
            <EmptyState.Content>
                <Link className="gap-1" href={PATH.PRODUCTS.ROOT}>
                    <Icon aria-hidden icon="gravity-ui:arrow-left" />
                    {t('products.notFound.back')}
                </Link>
            </EmptyState.Content>
        </EmptyState>
    );
};
